var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarning = function SvgWarning(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66664 11.334C8.66664 11.7022 8.36817 12.0007 7.99998 12.0007C7.63179 12.0007 7.33331 11.7022 7.33331 11.334C7.33331 10.9659 7.63179 10.6674 7.99998 10.6674C8.36817 10.6674 8.66664 10.9659 8.66664 11.334Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12397 2.48066C6.94457 1.0403 9.05538 1.0403 9.87598 2.48066L14.9907 11.4583C15.8054 12.8882 14.7304 14.6004 13.1147 14.6004H2.88523C1.26958 14.6004 0.1946 12.8882 1.00923 11.4583L6.12397 2.48066ZM8.83332 3.07468C8.47304 2.44229 7.52691 2.44229 7.16663 3.07468L2.05189 12.0523C1.71882 12.637 2.13765 13.4004 2.88523 13.4004H13.1147C13.8623 13.4004 14.2811 12.637 13.9481 12.0523L8.83332 3.07468ZM7.99994 5.40037C8.33131 5.40037 8.59994 5.669 8.59994 6.00037V9.3337C8.59994 9.66508 8.33131 9.9337 7.99994 9.9337C7.66856 9.9337 7.39994 9.66508 7.39994 9.3337V6.00037C7.39994 5.669 7.66856 5.40037 7.99994 5.40037Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "warning.cb81977711444220ce4d46e42f40c724.svg";